<template>
<div class="chapter">
<div class="inner_page">
<hr class="hr-part1"/>
<hr class="hr-part1a"/>
<h1 class="h1"><a id="part02"></a><a id="page_37">PART TWO</a></h1><a id="page_37">
<hr class="hr-part2"/>
<hr class="hr-part2a"/>
</a><h1 class="h1title"><a id="page_37">Across the Pacific</a><a id="page_38"></a></h1><a id="page_38">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?7bbf9452